import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateMemberPermissionsService, type AgendaPermission } from '@/services/agendas'

export const useUpdateMemberPermissions = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ targetUserId, permissions }: { targetUserId: string; permissions: AgendaPermission[] }) =>
      updateMemberPermissionsService(agendaId, targetUserId, permissions),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendas', agendaId, 'members'] })
    },
  })
}
